import { FC } from 'react';

import cs from 'classnames';

import TierPermissionsWrapper from 'components/TierPermissionsWrapper/TierPermissionsWrapper';

import { ClientTiers, MatchingTagTypes } from 'constants/enums';

import { useTranslation } from 'react-i18next';
import styles from './MatchingTag.module.scss';
import { MIN_MATCH_SCORE_TO_DISPLAY_TAG_PERC } from './constants';

interface MatchingTagProps {
  type?: MatchingTagTypes;
  matchingScore: number | null;
  jobName?: string | null;
  className?: string;
}

const MatchingTag: FC<MatchingTagProps> = ({
  type = MatchingTagTypes.Default,
  matchingScore,
  jobName,
  className = ''
}: MatchingTagProps) => {
  const { t } = useTranslation()
  if (!matchingScore || matchingScore <= MIN_MATCH_SCORE_TO_DISPLAY_TAG_PERC) {
    return null;
  }

  const label = t('matches.bestFit', { percent: matchingScore, jobName: jobName ?? '' })

  if (type === MatchingTagTypes.Simple) {
    return (
      <div className={styles.simpleTag}>
        <div className={styles.simpleTagText}>{`${matchingScore}%`}</div>
      </div>
    );
  }

  return (
    <TierPermissionsWrapper minimalTier={ClientTiers.Basic}>
      <div className={cs(styles.wrap, className)}>
        <div className={styles.tag}>{label}</div>
      </div>
    </TierPermissionsWrapper>
  );
};

export default MatchingTag;
